export const campaignSendersDomainRouteParamId = 'domainId' as const
export const campaignSendersDomainRouteQueryCheck = 'check' as const

export enum MessengerRouteNames {
  root = 'user.chats',
  index = 'user.chats.index',
}
